import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../../widgets/layout/CardUI'
import { useState } from 'react'
import ButtonTinyWithSpinnerUI from '../../../../widgets/action/ButtonTinyWithSpinnerUI'
import LastRepaymentScheduleModalSF from './LastRepaymentScheduleModalSF'
import RepaymentRemarksModalSF from './RepaymentRemarksModalSF'
import RepaymentDefaultsModalSF from './RepaymentDefaultsModalSF'
import RepaymentBalanceModalSF from './RepaymentBalanceModalSF'
import ButtonTinyUI from '../../../../widgets/action/ButtonTinyUI'
import LabelAndValueUI from '../../../../widgets/layout/LabelAndValueUI'
import RepaymentOpExpensesModalSF from './RepaymentOpExpensesModalSF'
import PaymentAmountModalSF from './PaymentAmountModalSF.js'
import ChargeAmountModalSF from './ChargeAmountModalSF.js'
import RepaymentChargeAmountModalSF from './RepaymentChargeAmountModalSF.js'
import RepaymentModalSF from './RepaymentModalSF'
import PenaltyModalSF from './PenaltyModalSF'
import './RepaymentList.css'
import RepaymentInterestModalSF from './RepaymentInterestModalSF'
import RepaymentPrincipalModalSF from './RepaymentPrincipalModalSF'
import { set } from 'date-fns'
import ButtonLinkUI from '../../../../widgets/action/ButtonLinkUI.js'

const RepaymentList2UI = ({ context, loan, totals, repaymentList,
  onRefreshClick, chargeAmountsList, account,
  updateRemarksMode, onUpdateRemarksClick, onCancelRemarksClick, selectedRepayment, selectedCharge,
  addPaymentMode, onAddPaymentClick, onCancelPaymentClick,
  addIntPriMode, onAddIntPriClick, onCancelIntPriClick, selectedChargeType,
  updateOpExpensesMode, onUpdateOpExpensesClick, onCancelOpExpensesClick,
  addChargeAmountMode, onAddChargeAmountClick, onCancelChargeAmountClick,
  updateDefaultsMode, onUpdateDefaultsClick, onCancelDefaultsClick,
  updateInterestMode, onUpdateInterestClick, onCancelInterestClick,
  updatePrincipalMode, onUpdatePrincipalClick, onCancelPrincipalClick,
  onDownloadPenalChargeClick, downloadPenalChargeSubmitted,
  updateBalanceMode, onUpdateBalanceClick, onCancelBalanceClick,
  onEmiPaymentClick, emiPaymentSubmitted, emiPaymentErrorList, selectedScheduledDate,
  onPenaltyClick, penaltySubmitted, onPenaltyCancelClick,
  onPayClick, paymentSubmitted, onPayCancelClick,
  addRowMode, onAddRowClick, onAddRowCancel, details, onDetailsClick
}) => {
  const [selectedPopRepayment, setSelectedRepayment] = useState(null);

  const handlePopupClose = () => {
    setSelectedRepayment(null);
  };
  return (
    <div className='su_rplst'>
      <span className='g_flex_h'>
        <Link to='#' onClick={onDetailsClick} >Details</Link>
        <Link to='#' onClick={onPayClick} >Initiate repayment</Link>
      </span>
      {
        repaymentList &&
        <CardUI className='g_m_top_50'>
          <table className='sched'>
            <thead className='g_sticky'>
              <tr className='head'>
                <td></td>
                <td className='g_text_center'>Scheduled</td>
                <td className='g_text_center'>Penal Charge</td>
                <td className='g_text_center'>Int On Overdue<br />Interest</td>
                <td className='g_text_center'>Int On Overdue<br />Principal</td>
                <td className='g_text_center'>Interest</td>
                <td className='g_text_center'>Principal</td>
                {
                  repaymentList.length > 0 && repaymentList[0].emiTaxList.length > 0 &&
                  <td className='g_text_center g_m_left_50'>EMI Tax</td>
                }
                <td className='g_text_center'>EMI</td>
                <td className='g_text_center'>Status</td>
                <td className='g_text_center'>Closing Balance</td>
              </tr>

            </thead>
            <tbody>
              {
                repaymentList.map((repayment, i) =>
                  <React.Fragment key={i}>
                    <tr>
                      <td>{i + 1}</td>
                      <td className='g_text_right'>
                        <a className='g_no_wrap_2' onClick={() => setSelectedRepayment(repayment)}>{repayment.scheduledDateF1}</a><br />
                        {
                          repayment.daysPastDue &&
                          <span className='g_text_right g_muted'>DPD: {repayment.daysPastDue}</span>
                        }
                      </td>
                      <ChargeUI chargeAmountsList={repayment.chargesAmountsList} repayment={repayment}
                        onAddPaymentClick={onAddPaymentClick} chargeType="default_interest" />
                      <ChargeUI chargeAmountsList={repayment.chargesAmountsList} repayment={repayment}
                        onAddPaymentClick={onAddPaymentClick} chargeType="interest_on_overdue_interest" />
                      <ChargeUI chargeAmountsList={repayment.chargesAmountsList} repayment={repayment}
                        onAddPaymentClick={onAddPaymentClick} chargeType="interest_on_overdue_principal" />

                      <InterestPaymentUI repayment={repayment} onAddIntPriClick={onAddIntPriClick} />
                      <PrincipalPaymentUI repayment={repayment} onAddIntPriClick={onAddIntPriClick} />

                      {
                        repaymentList.length && repaymentList[0].emiTaxList.length > 0 &&
                        <td key={i} className='g_text_center'>
                          {
                            repayment.emiTaxList.map((tax, j) =>
                              <span key={j}>
                                {j != 0 && <>+</>}
                                {tax.amountF5}
                              </span>
                            )
                          }
                        </td>
                      }
                      <EMIUI repayment={repayment} />
                      <td className='g_text_right'>
                        {
                          (!repayment.balanceAdjustedF5 || repayment.balanceF5 === repayment.balanceAdjustedF5) &&
                          <>{repayment.balanceF5}</>
                        }
                        {
                          repayment.balanceAdjustedF5 && repayment.balanceF5 !== repayment.balanceAdjustedF5 &&
                          <span className='g_flex_v'>
                            {repayment.balanceAdjustedF5}
                            <LabelAndValueUI label='Original' className='g_tiny'>{repayment.balanceF5}</LabelAndValueUI>
                          </span>
                        }
                      </td>
                      {
                        details &&
                        <td className='g_text_right'>
                          <span className='icon icon-pencil g_m_left_50 g_cursor_pointer g_muted' onClick={onUpdateRemarksClick}
                            data-scheduled-date={repayment.scheduledDate}>
                          </span>
                          <Link to='#' onClick={onUpdateBalanceClick} data-scheduled-dateISO={repayment.scheduledDateISO}>Update Balance</Link>
                        </td>
                      }
                      {
                        context.permissions.includes('su_superuser_business') &&
                        (repayment.status === 'unpaid' || repayment.defaultInterestStatus === 'unpaid') &&
                        repayment.defaultInterestStatus === 'unpaid' && (
                          <td>
                            <ButtonTinyUI
                              className='g_m_top_25'
                              label='Penalty'
                              onClick={onPenaltyClick}
                              rowId={repayment.scheduledDate}
                            />
                          </td>
                        )
                      }

                      {details && repayment.status !== 'paid' &&
                        <td>
                          <a href='#' className='g_m_left_50 g_cursor_pointer' onClick={onAddChargeAmountClick}
                            data-scheduled-date={repayment.scheduledDate} > Add Charges
                          </a>
                        </td>
                      }
                    </tr>

                    {
                      repayment.remarks && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>Internal remarks: {repayment.remarks}</td>
                      </tr>
                    }
                    {
                      repayment.oopExpenseRemarks && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>OOP expense remarks: {repayment.oopExpenseRemarks}</td>
                      </tr>
                    }
                    {
                      repayment.balanceAdjustedFormula && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>Balance calc: {repayment.balanceAdjustedFormula}</td>
                      </tr>
                    }
                    {
                      repayment.dsraHistoryList && repayment.dsraHistoryList.length > 0 && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>
                          {
                            repayment.dsraHistoryList.map((d, i) =>
                              <span key={i} className='g_flex_v'>
                                DSRA {d.status}: {d.dateF1}, amount: {d.dsraAmountF5} current: {d.dsraCurrentF5}
                              </span>
                            )
                          }
                        </td>
                      </tr>
                    }
                    {
                      repayment.dsraDipInterestFormula && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>
                          DSRA Int: {repayment.dsraDipInterestFormula.replace('(waived)', '')}
                          {
                            repayment.dsraDipInterestFormula.includes('(waived)') &&
                            <span className='g_muted'><b>(waived)</b></span>
                          }
                        </td>
                      </tr>
                    }
                    {
                      repayment.defaultHistoryList && repayment.defaultHistoryList.length > 0 && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>
                          {
                            repayment.defaultHistoryList.map((d, i) =>
                              <span key={i} className='g_flex_v'>
                                Default date: {d.defaultDateF1}, cure date: {d.cureDateF1}, on o/s balance: {d.balanceF4}
                                <span className='g_muted'>Default reason: {d.defaultReason}</span>
                              </span>
                            )
                          }
                        </td>
                      </tr>
                    }
                    {
                      repayment.defaultInterestFormula && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>Default Int: {repayment.defaultInterestFormula}</td>
                      </tr>
                    }
                    {
                      repayment.oopExpenseInterestFormula && details &&
                      <tr>
                        <td colSpan='16' className='g_muted g_tiny'>OOP Expense Interest: {repayment.oopExpenseInterestFormula}</td>
                      </tr>
                    }

                  </React.Fragment>
                )
              }
              <tr className='head'>
                <td className='g_text_center'></td>
                <td className='g_text_center'>Totals</td>
                <td className='g_text_center'>{totals.totalInterestF5}</td>
                <td className='g_text_center'>{totals.totalPrincipalF5}</td>
                <td className='g_text_center'>{totals.totalDefaultInterestF5}</td>
                <td></td>
                <td></td>
                <td className='g_text_center'>{totals.totalInterestPaidF5}</td>
                <td className='g_text_center'>{totals.totalPrincipalPaidF5}</td>
                <td className='g_text_center'>{totals.totalEMIF5}</td>
                <td className='g_text_center'></td>

                <td className='g_text_center'></td>
              </tr>
            </tbody>
          </table>
          {
            context && context.permissions.includes('su_superuser') &&
            <Link to='#' className='g_no_wrap_2 g_small' onClick={onAddRowClick}>Add Row</Link>
          }
        </CardUI>
      }

      {/* added noBusy */}
      <RepaymentRemarksModalSF context={context} loan={loan}
        updateMode={updateRemarksMode} onCancelClick={onCancelRemarksClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      {/* added noBusy */}
      <RepaymentOpExpensesModalSF context={context} loan={loan}
        updateMode={updateOpExpensesMode} onCancelClick={onCancelOpExpensesClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      {/* Added noBusy */}
      <PaymentAmountModalSF context={context} loan={loan}
        updateMode={addPaymentMode} onCancelClick={onCancelPaymentClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
        selectedCharge={selectedCharge}
      />

      {/* Added noBusy */}
      <ChargeAmountModalSF context={context} loan={loan}
        updateMode={addIntPriMode} onCancelClick={onCancelIntPriClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
        selectedChargeType={selectedChargeType}
      />

      {/* added noBusy */}
      <RepaymentChargeAmountModalSF context={context} loan={loan}
        updateMode={addChargeAmountMode} onCancelClick={onCancelChargeAmountClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      {/* added noBusy */}
      <RepaymentDefaultsModalSF context={context} loan={loan}
        updateMode={updateDefaultsMode} onCancelClick={onCancelDefaultsClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      {/* added noBusy */}
      <RepaymentInterestModalSF context={context} loan={loan}
        updateMode={updateInterestMode} onCancelClick={onCancelInterestClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      {/* added noBusy */}
      <RepaymentPrincipalModalSF context={context} loan={loan}
        updateMode={updatePrincipalMode} onCancelClick={onCancelPrincipalClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      {/* added noBusy */}
      <RepaymentBalanceModalSF context={context} loan={loan}
        updateMode={updateBalanceMode} onCancelClick={onCancelBalanceClick}
        onRefreshClick={onRefreshClick} selectedRepayment={selectedRepayment}
      />

      <PenaltyModalSF
        context={context} loan={loan} onRefreshClick={onRefreshClick}
        updateMode={penaltySubmitted} onCancelClick={onPenaltyCancelClick}
        selectedScheduledDate={selectedScheduledDate}
      />

      <RepaymentModalSF
        context={context} loan={loan} account={account} onRefreshClick={onRefreshClick}
        updateMode={paymentSubmitted} onCancelClick={onPayCancelClick}
      />

      <LastRepaymentScheduleModalSF
        context={context} loan={loan}
        createMode={addRowMode} onCancelClick={onAddRowCancel}
        onRefreshClick={onRefreshClick}
      />
      {selectedPopRepayment && (
        <Popup
          repayment={selectedPopRepayment}
          onClose={handlePopupClose}
        />
      )}
    </div>
  );
};


const EMIUI = ({ repayment }) =>
  <>
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {repayment.emiF5}
        {
          repayment.emiInitiatedDateF1 &&
          <LabelAndValueUI label='Initiated' className='g_tiny'>{repayment.emiInitiatedDateF1}</LabelAndValueUI>
        }
      </span>
    </td>
    <td className='g_text_right'>
      <span><i>{repayment.status}</i></span>
    </td>
  </>

// const InterestAmountUI = ({ repayment }) => (
//   <td className='g_text_right'>
//     <span className='g_flex_v'>
//       {repayment.interestAdjustedF5 && <span>{repayment.interestAdjustedF5}</span>}
//       {repayment.interestAdjustedF5 && repayment.interestF5 && (
//         <LabelAndValueUI label='Original' className='g_tiny'>
//           {repayment.interestF5}
//         </LabelAndValueUI>
//       )}
//       {!repayment.interestAdjustedF5 && repayment.interestF5 && <span>{repayment.interestF5}</span>}
//       {repayment.interestInitiatedDateF1 && (
//         <LabelAndValueUI label='Initiated' className='g_tiny'>
//           {repayment.interestInitiatedDateF1}
//         </LabelAndValueUI>
//       )}
//     </span>
//   </td>
// );

const InterestPaymentUI = ({ repayment, onAddIntPriClick }) => (
  <td className='g_text_right'>
    <span className='g_flex_v'>
      {repayment.interestAdjustedF5 && <span>{repayment.interestAdjustedF5}</span>}
      {repayment.interestAdjustedF5 && repayment.interestF5 && (
        <LabelAndValueUI label='Original' className='g_tiny'>
          {repayment.interestF5}
        </LabelAndValueUI>
      )}
      {!repayment.interestAdjustedF5 && repayment.interestF5 && <span>{repayment.interestF5}</span>}
      {repayment.interestInitiatedDateF1 && (
        <LabelAndValueUI label='Initiated' className='g_tiny'>
          {repayment.interestInitiatedDateF1}
        </LabelAndValueUI>
      )}
    </span>
    {repayment.status !== 'paid' && (
      <span
        className='g_cursor_pointer g_tiny g_no_wrap_2'
      >
        <a href="#"
          data-scheduled-date={repayment.scheduledDate}
          data-charge-type="interest"
          onClick={onAddIntPriClick}>
          Add Payment
        </a>
      </span>

    )}
    {repayment.chargesAmountsList &&
      repayment.chargesAmountsList
        .filter(charge => charge.chargeType === 'interest')
        .map((charge, index) => (
          <div key={index}>
            {charge.paymentHistoryList && charge.paymentHistoryList.map((payment, j) => (
              <div key={j} className='g_tiny g_m_left_50'>
                <span>{payment.amountF5 || "N/A"}</span>
              </div>
            ))}
          </div>
        ))}
  </td>
);

// const PrincipalAmountUI = ({ repayment }) => (
//   <td className='g_text_right'>
//     <span className='g_flex_v'>
//       {repayment.principalF5}
//       {repayment.principalInitiatedDateF1 && (
//         <LabelAndValueUI label='Initiated' className='g_tiny'>
//           {repayment.principalInitiatedDateF1}
//         </LabelAndValueUI>
//       )}
//     </span>
//   </td>
// );

const PrincipalPaymentUI = ({ repayment, onAddIntPriClick }) => {

  return (
    <td className='g_text_right'>
      <span className='g_flex_v'>
        {repayment.principalF5}
        {repayment.principalInitiatedDateF1 && (
          <LabelAndValueUI label='Initiated' className='g_tiny'>
            {repayment.principalInitiatedDateF1}
          </LabelAndValueUI>
        )}
      </span>
      {repayment.status !== 'paid' && (
        <span
          className='g_cursor_pointer g_tiny g_no_wrap_2'
        >
          <a
            href="#"
            data-scheduled-date={repayment.scheduledDate}
            data-charge-type="principal"
            onClick={onAddIntPriClick}
          >
            Add Payment
          </a>
        </span>


      )}
      {repayment.chargesAmountsList && repayment.chargesAmountsList.length > 0 &&
        repayment.chargesAmountsList
          .filter(charge => charge.chargeType === 'principal')
          .map((charge, index) => (
            <div key={index}>
              {charge.paymentHistoryList && charge.paymentHistoryList.length > 0 &&
                charge.paymentHistoryList.map((payment, j) => (
                  <div key={j} className='g_tiny g_m_left_50 '>
                    <span>{payment.amountF5 || "N/A"}</span>
                  </div>
                ))}
            </div>
          ))}
    </td>
  )
};

const Popup = ({ repayment, onClose }) => {
  const chargeOrder = [
    'default_interest',
    'interest_on_overdue_interest',
    'interest_on_overdue_principal',
    'interest',
    'principal'
  ];

  const sortedCharges = repayment.chargesAmountsList
    ? repayment.chargesAmountsList.sort((a, b) => chargeOrder.indexOf(a.chargeType) - chargeOrder.indexOf(b.chargeType))
    : [];

  return (
    <div className='popup'>
      <div className='popup-inner'>
        <div className='g_flex_h'>
          <h2>{`Repayment(${repayment.scheduledDateF1}) Details`}</h2>
          <button style={{ border: 'none' }} onClick={onClose}>&times;</button>
        </div>
        <table className='popup-table'>
          <thead>
            <tr>
              <th>Charge Type</th>
              <th>Amount</th>
              <th>Payments</th>
            </tr>
          </thead>
          <tbody>
            {sortedCharges.length > 0 ? (
              sortedCharges.map((charge, index) => (
                <ChargeRow key={index} charge={charge} />
              ))
            ) : (
              <tr>
                <td colSpan="5">No charges available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const ChargeRow = ({ charge }) => {
  return (
    <>
      <tr>
        <td>
          {charge.chargeType}
          <br />
          {
            charge.chargeType !== 'interest' && charge.chargeType !== 'principal' &&
            <div>
              {charge.formula &&
                <small className='formula'><b>Formula: </b>{charge.formula}</small>
              }
              {charge.formula &&
                <br />
              }
              {charge.chargeStartDateISO &&
                <small><b>Start Date: </b>{charge.chargeStartDateISO}</small>
              }
              {charge.chargeStartDateISO &&
                <br />
              }
              {charge.chargeEndDateISO &&
                <small><b>Cure Date: </b>{charge.chargeEndDateISO}</small>
              }
            </div>
          }
        </td>
        <td>{charge.amountF5 || "N/A"}</td>
        <td>
          {
            charge.paymentHistoryList && charge.paymentHistoryList.length > 0 &&
            <table style={{ fontSize: '8px', borderCollapse: 'collapse', maxWidth: '100%' }}>
              {
                charge.chargeType === 'default_interest' &&
                <tr>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              }
              {charge.paymentHistoryList.map((payment, index) => (
                <tr>
                  <td style={{ fontSize: '8px', textWrap: 'nowrap' }}>{payment.initiatedDateF1}</td>
                  <td>{payment.amountF5 || "N/A"}</td>
                </tr>
              ))}
            </table>
          }
        </td>
      </tr>
    </>
  );
};

const ChargeUI = ({ chargeAmountsList, chargeType, onAddPaymentClick, repayment }) => {
  return (
    <React.Fragment>
      <td className='g_text_right'>
        {chargeAmountsList && chargeAmountsList.length > 0 &&
          chargeAmountsList
            .filter((c) => c.chargeType === chargeType)
            .map((charge, i) => (
              <div className="g_flex_v g_flex_top" key={i}>
                <span>
                  {charge.amountF5 || "N/A"}
                </span>
                <a key={i}
                  className='g_cursor_pointer'
                  data-scheduled-date={repayment.scheduledDate}
                  data-created-date={charge.dateCreated}
                  data-charge-type={charge.chargeType}
                  href='#'
                  onClick={onAddPaymentClick}>
                  Add Payment
                </a>
                {charge.paymentHistoryList && charge.paymentHistoryList.length > 0 && (
                  charge.paymentHistoryList.map((payment, j) => (
                    <div key={j} className='g_m_left_100 g_tiny'>
                      <span>{payment.amountF5 || "N/A"}</span>
                    </div>
                  ))
                )
                }
              </div>
            ))}
      </td>
    </React.Fragment>
  );
};

export default RepaymentList2UI
